import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=5122a2f8&"
import script from "./Assign.vue?vue&type=script&lang=js&"
export * from "./Assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports